import { createFileRoute } from "@tanstack/react-router";

/** Bên trong một album ngoài đơn (QĐ 0306) — mã trên đường dẫn là mã kho chứa. */
export const Route = createFileRoute("/_app/gallery/albums/$containerId")({});
